import React from 'react'
import "./Home.css"
import Product from './Product'
import Catalogo from './Catalogo'
import cubre from './Imagenes/cubre.jpg'
import blur from './Imagenes/blur.jpg'
import circulo from './Imagenes/circulo.png'
import pres from './Imagenes/presentación.png'

function Home() {
    return (
        <div className="home">
            
            <div className="home_container">
                <div className="home_header">
                <div className= "hero_inner">
                <div className= "page-width text-center2">
                <h2 className= "mega-title">Insumos Médicos Mar</h2>
                <div className= "rte-setting mega-subtitle">
<p>En INMAR buscamos brindar servicios y productos de valor; acorde a los estándares de calidad que puedan servir 
   a Hospitales, personal médico y pacientes. 
</p>
</div>
</div>
</div>
<img className= "home_circulo"
                src={circulo}
                alt=""
                />  
<img className= "home_image"
                src={blur}
                alt=""
                />     
</div>
            <div className= "section-header text-center">
            <h2>Nuestros productos</h2>
            </div>
            <div className= "catalogo_row catalogo_row_fill">
            <div className="col"><Catalogo color= 'rgb(142, 165, 175)' title= 'Equipo Médico' image= "http://pngimg.com/uploads/mechanical_ventilator/mechanical_ventilator_PNG26.png"/></div>
            <div className="col"><Catalogo color= 'rgb(142, 165, 175)' title= 'Insumos Médicos'image="http://pngimg.com/uploads/mechanical_ventilator/mechanical_ventilator_PNG1.png"/></div>
            <div className="col"><Catalogo color= 'rgb(142, 165, 175)' title='Ropa Quirurjica' image="http://pngimg.com/uploads/medical_mask/medical_mask_PNG49.png"/></div>
            <div className="col"><Catalogo color= 'rgb(142, 165, 175)' title='Pruebas' image="http://pngimg.com/uploads/thermometer/thermometer_PNG63.png"/></div>
            <div className="col"><Catalogo color='rgb(142, 165, 175)' title='Mascarillas' image="http://pngimg.com/uploads/medical_mask/medical_mask_PNG53.png"/></div>
            </div>

            <div className= "Home_cubre">
            <img src= {cubre} />
                <div className="Home_Cubre_text Cubre_text">En INMAR ofrecemos lo mejor para cuidar de todos</div>
            </div>

             <div className= "section-header text-center">
        <h2>Los mas vendidos</h2>
        </div>
            <div className= "home_row">
             <Product  id= "1" title='Cubrebocas KN95 Certificado Precio Mayoreo Mascarilla 10pz' price= {29.99} image="http://pngimg.com/uploads/medical_mask/medical_mask_PNG53.png"
             rating= {5}/> 
             <Product id= "8" title='Microflex SG375L SafeGrip Powder Free Latex Glove Size Large (Box of 50)' price= {39.99} image="http://pngimg.com/uploads/medical_gloves/medical_gloves_PNG130.png"
             rating= {2}/>   
            <Product id= "2" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/thermometer/thermometer_PNG63.png"
             rating= {5}/>     
            <Product id= "3" title='Tobacco: A Cultural History of How an Exotic Plant Seduced Civilization' price= {15.99} image="http://pngimg.com/uploads/tobacco/tobacco_PNG36.png"
             rating= {3}/>  
            <Product id= "4" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/multi_tool/multi_tool_PNG93.png"
             rating= {5}/>     
            <Product id= "5" title='Tobacco: A Cultural History of How an Exotic Plant Seduced Civilization' price= {15.99} image="http://pngimg.com/uploads/tobacco/tobacco_PNG36.png"
             rating= {3}/>   
            <Product  id= "6" title='Westmon Works Seashell Driftwood Decoración móvil para el hogar de 6 pulgadas de largo' price= {89.99} image="http://pngimg.com/uploads/seashell/seashell_PNG83.png"
             rating= {4}/>  
             <Product id= "7" title='Cycling Fishing Golf Blade Sport Polarized Sunglasses' price= {10.00} image="http://pngimg.com/uploads/hammer/hammer_PNG1131.png"
             rating= {5}/> 
            </div> 
            
            <div className= "Home_pres">
            <img src= {pres} />
                <div className="Home_pres_text pres_text">Nuestra visión es lograr tener todos los insumos necesarios para ser el primer lugar de ventas de insumos en la región.</div>
            </div>
        </div>
        </div>
    )
}

export default Home
